/** Theme toggle — matches blueprint .theme-tg behavior. */
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../../contexts/ThemeContext";
import { cn } from "../../lib/cn";

export function ThemeToggle({ className }) {
  const { theme, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      aria-label="Toggle theme"
      data-testid="theme-toggle"
      className={cn(
        "inline-flex items-center justify-center w-10 h-10 rounded-full border border-line-2 bg-surface text-text hover:border-mauve hover:bg-surface-2 transition-colors",
        className
      )}
    >
      {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
}
